import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-sm-12 q-pr-xl" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "col-md-6 col-sm-12 variants" }
const _hoisted_6 = { class: "row justify-between" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_product_option_card = _resolveComponent("product-option-card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_lock_closed_icon = _resolveComponent("lock-closed-icon")!
  const _component_pen_icon = _resolveComponent("pen-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_product_variant_card = _resolveComponent("product-variant-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: "options-and-variants",
    onDblclick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editing = !_ctx.locked))
  }, [
    (!_ctx.editing && !_ctx.locked)
      ? (_openBlock(), _createBlock(_component_tooltip, {
          key: 0,
          selector: ".options-and-variants",
          "tooltip-value": "Double click to edit"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Options", -1)),
        (!_ctx.editing)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Available options based on (variant-) main component properties (max.3)"))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, "By adding options you can create variants to this product.")),
        _createVNode(_component_draggable, _mergeProps({
          modelValue: _ctx.productOptionsEditState,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productOptionsEditState) = $event)),
          handle: ".drag"
        }, _ctx.dragOptions, {
          onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag.options = true)),
          onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag.options = false)),
          "item-key": "sys.id"
        }), {
          item: _withCtx(({ element: productOption, index }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["drag-handle-container", { editing: _ctx.editing }])
            }, [
              (_ctx.editing)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    class: "drag",
                    name: "drag_indicator",
                    size: "22px"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_product_option_card, {
                editing: _ctx.editing,
                "product-option": productOption,
                "prop-values": _ctx.propValues,
                "prop-choices": _ctx.propChoices,
                "onUpdate:productOption": ($event: any) => (_ctx.updateProductOption($event, index)),
                "onRemove:productOption": ($event: any) => (_ctx.removeProductOption(index))
              }, null, 8, ["editing", "product-option", "prop-values", "prop-choices", "onUpdate:productOption", "onRemove:productOption"])
            ], 2)
          ]),
          _: 1
        }, 16, ["modelValue"]),
        (_ctx.editing && _ctx.productOptionIdsEditState.length < 3)
          ? (_openBlock(), _createBlock(_component_d_button, {
              key: 2,
              class: "q-mr-md",
              onClick: _ctx.addOption,
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_add_icon, { left: "" }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Option", -1))
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Variants", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.locked)
              ? (_openBlock(), _createBlock(_component_lock_closed_icon, { key: 0 }))
              : (!_ctx.editing)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing = true)),
                    outline: "",
                    unelevated: "",
                    rounded: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_pen_icon, { left: "" }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", null, "Edit", -1))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_q_btn, {
                      class: "q-mr-md",
                      onClick: _ctx.cancel,
                      flat: "",
                      unelevated: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close_icon, { left: "" }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Cancel", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      onClick: _ctx.save,
                      unelevated: "",
                      rounded: "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_tick_icon, { left: "" }),
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Save", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
          ])
        ]),
        (_ctx.editing)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Combine the selected options to create variants to this product."))
          : _createCommentVNode("", true),
        _createVNode(_component_draggable, _mergeProps({
          modelValue: _ctx.productVariantsEditState,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productVariantsEditState) = $event)),
          handle: ".drag"
        }, _ctx.dragOptions, {
          onStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag.variants = true)),
          onEnd: _cache[6] || (_cache[6] = ($event: any) => (_ctx.drag.variants = false)),
          "item-key": "sys.id"
        }), {
          item: _withCtx(({ element: productVariant, index }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["drag-handle-container", { editing: _ctx.editing }])
            }, [
              (_ctx.editing)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    class: "drag",
                    name: "drag_indicator",
                    size: "22px"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_product_variant_card, {
                editing: _ctx.editing,
                "product-variant": productVariant,
                "product-options": _ctx.productOptionsEditState,
                "prop-values": _ctx.propValues,
                "onUnlink:productVariant": ($event: any) => (_ctx.unlinkProductVariant(index)),
                "onUpdate:optionValue": ($event: any) => (_ctx.updateOptionValue(index, ...$event)),
                "onUpdate:productVariant": ($event: any) => (_ctx.updateProductVariant(index, $event))
              }, null, 8, ["editing", "product-variant", "product-options", "prop-values", "onUnlink:productVariant", "onUpdate:optionValue", "onUpdate:productVariant"])
            ], 2)
          ]),
          _: 1
        }, 16, ["modelValue"]),
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_d_button, {
              key: 1,
              class: "q-mr-md",
              onClick: _ctx.addVariant,
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_add_icon, { left: "" }),
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Variant", -1))
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}